import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CasoGeneralComponent } from 'defcol-caso-general'
import AdministracionForm from './formulario'
import { obtenerDatosLlaves } from '../../store/actions/gestion-defensa-action'
import { Auth } from 'recupero-comunes'
import { useLocation, useNavigate } from 'react-router-dom'
import { Card, Container} from 'react-bootstrap'
import 'recupero-comunes/dist/index.css'

const GestionDefensa = () => {

  const {state}=useLocation()
  const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso:2
  const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado:0
  const idOrganizacionCaso =state?.row?.idOrganizacionCaso ? state.row.idOrganizacionCaso:8600399880
  const { rutUsuario } = Auth.currentUser()
  const dispatch = useDispatch()
  const history = useNavigate()

  useEffect(() => {
    
    if (idCasoLocation && idCasoLocation > 0) {
      dispatch(obtenerDatosLlaves({"idCaso":idCasoLocation,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso, "idUsuario": rutUsuario}));
    } else {
      const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoDirecto'))
      setTimeout(()=> history('/area-trabajo-recupero-directo',{state:{queryState}}),2000);      
    }
  }, [dispatch])

  return (
    <div>
      <Container>
      <Card className='mt-2'>
        <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >{`Gestión Caso Asignado ${idCasoLocation}`}</Card.Header>
        <Card.Body>
         <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} />
      </Card.Body>
      </Card>
    </Container>
      <AdministracionForm />
    </div>
  )
}

export default GestionDefensa 